<!--
 * @Author: your name
 * @Date: 2021-06-21 16:09:10
 * @LastEditTime: 2021-08-30 18:05:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\views\Im\Im.vue
-->
<template>
  <div class="box">
    <div class="prompt" v-if="list == ''">快去聊天吧</div>
    <div class="msg" v-else>
      <div class="msg-h">
        <div v-if="list">
            <span v-if=" list.imName">{{ list.imName }}</span>
            <span v-else>{{list.userProfile.nick}}</span>
            <a-icon v-if="list.userProfile && list.userProfile.nick != '系统通知'" type="phone" />
           <span style="font-weight: normal; font-size: 15px">
          (
          <span v-if="list.toAccount">{{ list.toAccount }}</span>
          <span v-else>{{ list.imAccount }}</span>

          )</span
        >
        </div>
      </div>
      <div class="msg-t" id="gundong">
        <div class="chat-main">
          <div class="chat-left" v-for="(item, index) in message" :key="index">
            <div class="chat-time">{{ item.time | formatDate }}</div>
            <!-- 左边 -->
            <div class="msg-m msg-left" v-if="item.to == account">
              <img
                :src="
                  item.avatar ||
                  'https://zlt-2021.oss-cn-zhangjiakou.aliyuncs.com/eshop/2021/10/27/1564689964724129792.png'
                "
                alt=""
              />
              <!-- 文字 -->
              <div
                class="message"
                v-if="item.type == 'TIMTextElem' && item.payload"
              >
                <div class="msg-text">{{ item.payload.text }}</div>
              </div>
              <!-- <div class="message" v-else>
                                <div class="msg-text">{{item.message}}</div>
                            </div> -->
              <!-- 图片 -->
              <div
                class="imgs"
                v-if="item.type == 'TIMImageElem' && item.payload"
              >
                <img :src="item.payload.imageInfoArray[0].imageUrl" alt="" />
                <!-- <img v-else :src="item.message" alt=""> -->
              </div>
              <!-- 自定义消息 -->
              <div class="define1" v-if="item.type == 'TIMCustomElem'">
                <div class="boxs" @click="product(item)">
                  <div style="height: 80px; width: 80px">
                    <img
                      style="width: 80px; height: 75px"
                      :src="item.payload.data.imageUrl"
                      alt=""
                    />
                  </div>
                  <div style="width: 200px; height: 80px; padding: 0 0 0 8px">
                    <div class="title">
                      {{ item.payload.data.productDescription }}
                    </div>
                    <div class="geographic">
                      <div>{{ item.payload.data.origin }}</div>
                      --
                      <div>{{ item.payload.data.destination }}</div>
                      <div style="color: rgb(235, 85, 85)">
                        ￥{{ item.payload.data.price }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 右边 -->
            <div class="msg-m msg-right" v-if="item.to != account">
              <img :src="item.avatar" alt="" />
              <!-- 文字 -->
              <div class="message" v-if="item.type == 'TIMTextElem'">
                <div v-if="item.payload" class="msg-text">
                  {{ item.payload.text }}
                </div>
                <div v-else class="msg-text">{{ item.message }}</div>
              </div>
              <!-- 图片 -->
              <div
                class="imgs"
                v-if="item.type == 'TIMImageElem' && item.payload"
              >
                <img :src="item.payload.imageInfoArray[0].imageUrl" alt="" />
                <!-- <img v-else :src="item.message" alt=""> -->
              </div>
              <!-- 自定义消息 -->
              <div class="define" v-if="item.type == 'TIMCustomElem'">
                <div class="boxs" @click="product(item)">
                  <div style="height: 80px; width: 80px">
                    <img
                      style="width: 80px; height: 75px"
                      :src="item.payload.data.imageUrl"
                      alt=""
                    />
                  </div>
                  <div style="width: 200px; height: 80px; padding: 0 0 0 8px">
                    <div class="title">
                      {{ item.payload.data.productDescription }}
                    </div>
                    <div class="geographic">
                      <div>{{ item.payload.data.origin }}</div>
                      --
                      <div>{{ item.payload.data.destination }}</div>
                      <div style="color: rgb(235, 85, 85)">
                        ￥{{ item.payload.data.price }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="suspension" v-if="suspension">
          <div class="suspension_img">
            <img :src="message_.customVo.imageUrl" alt="" />
          </div>
          <div class="suspension_title">
            <div class="suspension_title1">
              {{ message_.customVo.productDescription }}
            </div>
            <div class="suspension_title2">
              <span>{{ message_.customVo.origin }}</span>
              ——
              <span>{{ message_.customVo.destination }}</span>
              <span style="color: rgb(235, 85, 85)"
                >￥{{ message_.customVo.price }}</span
              >
              <span class="suspension_but" @click="sendtheProduct"
                >发送产品</span
              >
            </div>
          </div>
          <div class="suspension_title3" @click="cancel">X</div>
        </div>
      </div>

      <div class="msg-c">
        <div class="more-list" @click="sendId">
          <img src="../../../assets/im/T.png" alt="" />
        </div>
        <input
          type="file"
          id="imagePicker"
          ref="imagePicker"
          accept=".jpg, .jpeg, .png, .gif, .bmp"
          @change="sendImage"
          style="display: none"
        />
        <div class="more-list">
          <img src="../../../assets/im/W.png" alt="" />
        </div>
        <div class="more-list">
          <img src="../../../assets/im/S.png" alt="" />
        </div>
        <div class="more-list">
          <img src="../../../assets/im/Z.png" alt="" />
        </div>
      </div>
      <div class="msg-b">
        <a-textarea
         @pressEnter="send"
          class="chat-sed"
          :autosize="false"
          v-model="values"
        ></a-textarea>
        <div class="but sendbtn" @click="send">发送</div>
        <div id="talkbubble" class="inlayer" v-show="shows">不能发送空消息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../../utils/eventBus.js";
import datas from "../information.js";
import { formatDate } from "../time.js";
import { sendMsgs } from "../../../api/im.js";
export default {
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      console.log(new Date(time));
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  components: {},
  data() {
    return {
      aa: false,
      list: [],
      message: [], //消息列表
      values: "", //输入值
      shows: false,
      account: "", //获取当前账号
      name: [],
      lists: [],
      suspension: false,
      message_: {
        sendMessageVO: {
          from_Account: "",
          to_Account: "",
          msgBody: [
            {
              msgType: "TIMCustomElem",
              msgContent: {
                data: "",
              },
            },
          ],
        },
        customVo: {
          productDescription:
            "啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊额威风威风威风威风威风为分为非威风威风威风威风威风为分为非我饿分为范围分为范围分为范围分为",
          url: "",
          imageUrl:
            "https://img2.woyaogexing.com/2021/07/02/70ef8c16dd83441f8c67bda6728cca44!400x400.jpeg",
          shopCode: "",
          productCode: "",
          userCode: "",
          orgCode: "",
          price: "666",
          origin: "大理",
          destination: "西安",
          productSource: "",
          productShare: "",
          businessAreaCode: "",
          businessAreaType: "",
          productTypeId: "",
        },
      },
    };
  },
  mounted() {},
  
  mounted() {
    var that = this;
    (this.account = localStorage.getItem("imAccount")),
      // this.message = datas.message()
      eventBus.$on("aa", (value) => {
        this.list = value;
        this.autoBottom()
      });
    eventBus.$on("bb", (value) => {
      this.message = value;
    });
    eventBus.$on("cc", (value) => {
      this.list = value;
      // console.log(this.list.imAccount, '======================================')
    });
    that.$tim.on(that.$TIMS.EVENT.MESSAGE_RECEIVED, (event) => {
      console.log("--------新消息进来了---------");
      that.getMessage();
      console.log("--------新消息进来了2222---------");
    });
  },
  methods: {
    autoBottom(){
      var that = this;
        // 始终最后一条消息位置
        setTimeout(function () {
          // console.log("最底部------------------");
          that.$nextTick(() => {
            let msg = document.getElementById("gundong"); // 获取对象
            msg.scrollTop = msg.scrollHeight; // 滚动高度
            // console.log(msg,'----')
          });
        }, 500);
      },
    // 发送按钮
    send() {
      if (this.values == "") {
        this.shows = true;
        setInterval(() => {
          this.shows = false;
        }, 2000);
        clearInterval();
      } else {
        var that = this;
        let data = {
          from_Account: this.account,
          to_Account: this.list.userProfile
            ? this.list.userProfile.userID
            : this.list.imAccount,
          msgBody: [
            {
              msgType: "TIMTextElem",
              msgContent: {
                text: that.values,
              },
            },
          ],
        };
        sendMsgs(data).then((res) => {
          if (res.code == 200) {
            // console.log(res, '=================')
            that.getMessage();
          }
        });
        console.log(data);
        var msg = {
          id: data.from_Account,
          imgurl: "",
          message: data.msgBody[0].msgContent.text,
          type: data.msgBody[0].msgType,
          time: "13:01",
        };
        this.message.push(msg);
        // 获取最后一条消息的位置
        this.$nextTick(() => {
          let msg = document.getElementById("gundong"); // 获取对象
          msg.scrollTop = msg.scrollHeight; // 滚动高度
        });
        setTimeout(() => {
          this.values = "";
        }, 0);
      }
    },

    //发送图片
    sendId() {
      this.$refs.imagePicker.click();
    },

    // 获取历史消息
    getMessage() {
      var that = this;
      console.log(that.list, "========获取历史记录前当前的信息============");
      if (that.list != "") {
        var conversationID = "";
        if(that.list && that.list.conversationID){
          conversationID = that.list.conversationID
        }else if(that.list && that.list.imAccount){
          conversationID = "C2C" +that.list.imAccount
        }else if(that.list){
           conversationID = "C2C" +that.list
        }else{
          conversationID = ""
        }
        let promise = that.$tim.getMessageList({
          conversationID:conversationID ,
          count: 1000,
        });
        promise.then(function (imResponse) {
          const messageList = imResponse.data.messageList; // 消息列表。
          console.log(messageList, '消息记录列表')
          that.messages = messageList;
          that.messages.forEach((item) => {
            if (item.type == "TIMCustomElem") {
              if (item.payload.data && item.payload.data != "[object Object]") {
                item.payload.data = JSON.parse(item.payload.data);
              }
            }
          });
          that.message = messageList;
          that.$nextTick(() => {
            let msg = document.getElementById("gundong"); // 获取对象
            msg.scrollTop = msg.scrollHeight; // 滚动高度
          });
          const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
          const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
        });
      }
    },

    sendImage() {
      var that = this;
      const message = this.$tim.createImageMessage({
        to: this.list ? this.list.userProfile.userID : this.list[0].imAccount,
        conversationType: "C2C",
        payload: {
          file: document.getElementById("imagePicker"), // 或者用event.target
        },
        onProgress: (percent) => {
          this.$set(message, "progress", percent); // 手动给message 实例加个响应式属性: progress
        },
      });
      // this.$store.commit("pushCurrentMessageList", message);
      this.$tim
        .sendMessage(message)
        .then((res) => {
          console.log(res, "22222222222222222222222222222");
          // this.$refs.imagePicker.value = null;
          var data = {
            from_Account: that.account,
            to_Account: that.list.userProfile.userID,
            msgBody: [
              {
                msgType: "TIMImageElem",
                msgContent: {
                  UUID: res.data.message.payload.uuid,
                  imageFormat: res.data.message.payload.imageFormat,
                  imageInfoArray: res.data.message.payload.imageInfoArray,
                },
              },
            ],
          };
          that.getMessage();
          // sendMsgs(data).then(res => {
          //     console.log(res)
          // })
        })
        .catch((imError) => {
          this.$store.commit("showMessage", {
            message: imError.message,
            type: "error",
          });
        });
    },
    // 自定义消息
    product(e) {
      console.log(e, "=============");
      this.$router.replace(
        "/product-detail?productCode=" +
          e.payload.data.productCode +
          "&productType=" +
          e.payload.data.productTypeId +
          "&source=" +
          (e.payload.data.productSource || 1) +
          "&businessAreaCode=" +
          e.payload.data.businessAreaCode +
          "&businessAreaType=" +
          e.payload.data.businessAreaType
      );
    },
    cancel() {
      this.suspension = false;
    },
    sendtheProduct() {
      var that = this;
      this.suspension = false;
      let message = that.$tim.createCustomMessage({
        // to: ,
        conversationType: "C2C",
        payload: {
          data: JSON.stringify(that.message_), // 用于标识该消息是骰子类型消息
          description: String(1), // 获取骰子点数
          extension: "",
        },
      });
      let promise = that.data.timWx.sendMessage(message);
      promise
        .then(function (imResponse) {
          // 发送成功
          that.message.push(imResponse.data.message);
          console.log(that.message, "--------");
          that.message.forEach((item) => {
            if (item.type == "TIMCustomElem") {
              if (item.payload.data && item.payload.data != "[object Object]") {
                item.payload.data = JSON.parse(item.payload.data);
              }
            }
          });
          that.getMessage();
          console.log(that.message, "自定义消息产品");
        })
        .catch(function (imError) {
          // 发送失败
          console.warn("sendMessage error:", imError);
        });
    },
  },
  // props: ["name"]
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 70%;
}

.msg {
  width: 100%;
  height: 654px;
  /* border: 1px solid #333; */
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: #f5f5f5;
}

.msg-h {
  width: 100%;
  height: 8%;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  font-size: 22px;
  font-weight: bold;
  padding: 10px 20px;
  border-top-right-radius: 15px;
}

.msg-t {
  width: 100%;
  height: 62%;
  /* border: 1px solid #f90; */
  overflow-y: auto;
  /* position: relative; */
  border-right: 1px solid #ccc;
}

.msg-t::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.msg-t::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  background: rgb(201, 201, 201);
}

.msg-t::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  border-radius: 5px;
  background: #ededed;
}

.msg-c {
  width: 100%;
  height: 5%;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  background: white;
}

.msg-b {
  width: 100%;
  height: 25%;
  /* border: 1px solid #f90; */
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom-right-radius: 15px;
  overflow: hidden;
  position: relative;
}

.prompt {
  text-align: center;
  margin: 300px auto;
  color: rgb(175, 175, 175);
}

.chat-main {
  padding-left: 5px;
  padding-top: 33px;
  padding-right: 5px;
  display: flex;
  flex-direction: column;
  /* border: 1px solid #f90; */
}
.chat-sed {
  width: 100%;
  height: 184px;
  border: none;
  padding-bottom: 20px;
}
.chat-sed:hover {
  border: none;
}
.chat-time {
  font-size: 12px;
  color: #333;
  line-height: 17px;
  padding: 10px 0;
  text-align: center;
}

.msg-m {
  display: flex;
  padding: 10px 0;
}

.msg-left .msg-text {
  font-size: 15px;
  color: #333;
  padding: 8px 12px;
  border-radius: 0 10px 10px 10px;
  background: #fffffe;
  margin-left: 8px;
}

.msg-m img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.message {
  max-width: 250px;
  word-break: break-all;
}

.imgs img {
  width: 150px;
  height: 150px;
  margin-left: 8px;
}

.msg-left {
  flex-direction: row;
}

.msg-right {
  flex-direction: row-reverse;
}

.msg-right .msg-text {
  font-size: 15px;
  color: #333;
  padding: 8px 12px;
  border-radius: 10px 0px 10px 10px;
  /* background: rgb(236, 219, 120); */
  background:#98e165 ;
  margin-right: 8px;
}

.btn {
  flex: auto;
  background-color: #fff;
  border-radius: 5px;
  border-bottom-right-radius: 21px;
  padding: 10px;
  max-height: 163px;
  /* min-height: 70rpx; */
  /* margin: 0 5px; */
  height: 165px;
  width: 100%;
  position: relative;
  overflow-y: auto;
}

.but {
  display: inline-block;
  width: 70px;
  line-height: 30px;
  text-align: center;
  color: #353535;
  background-color: #ececec;
  font-size: 14px;
  border-radius: 2px;
  border: 1px solid #bebebe;
  position: absolute;
  right: 12px;
  bottom: 10px;
  cursor: pointer;
}

.but:hover {
  background-color: #57b94e;
  border: 1px solid #57b94e;
  color: #fffffe;
}

.btn::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.btn::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  background: rgb(201, 201, 201);
}

.btn::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgb(201, 201, 201);
  border-radius: 5px;
  background: #ededed;
}

#talkbubble {
  width: 120px;
  line-height: 30px;
  position: absolute;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 5px;
  border: 1px #808080 solid;
  background-color: #fff;
  bottom: 60px;
  right: 10px;
  text-align: center;
}

#talkbubble:before {
  content: " ";
  position: absolute;
  top: 100%;
  left: 77px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-top: 15px solid #808080;
  border-right: 15px solid transparent;
}

.inlayer:after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 77.5px;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-top: 14px solid #fff;
  border-right: 14px solid transparent;
}

.more-list {
  width: 50px;
  text-align: center;
  float: left;
  /* padding-top: 30rpx */
}

.more-list img {
  cursor: pointer;
  width: 30px;
  height: 30px;
  /* padding: 10px; */
  border-radius: 10px;
}

.tab1,
.tab2 {
  width: 100%;
  height: 100%;
  /* background: orange; */
}

.tab {
  width: 50%;
  height: 80rpx;
  text-align: center;
  line-height: 80rpx;
  background: #f0f0f0;
  padding: 5rpx;
}

.prompt {
  text-align: center;
  margin: 300px auto;
  color: rgb(175, 175, 175);
}

.define1 {
  background-color: #fffffe;
  width: 300px;
  margin: 0 0px 0 7.5px;
  cursor: pointer;
  border-radius: 0px 10px 10px 10px;
}

.define {
  /* background-color: #ecdb78; */
  background: #98e165;
  cursor: pointer;
  width: 300px;
  margin: 0 7.5px 0 0px;
  border-radius: 10px 0px 10px 10px;
}

.boxs {
  display: flex;
  flex-direction: row;
  padding: 7.5px;
  margin-top: 5px;
}

.title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 45px;
  /* border: 1px solid #f90; */
}

.geographic div {
  display: inline-block;
  /* margin-top: 4px; */
}

.suspension {
  width: 520px;
  height: 100px;
  background-color: rgb(175, 175, 175);
  border-radius: 10px;
  position: absolute;
  bottom: 210px;
  left: 410px;
  display: flex;
  flex-direction: row;
}

.suspension_img {
  width: 22%;
  height: 100%;
  border: 1px solid #f90;
}

.suspension_title {
  width: 75%;
  height: 100%;
  border: 1px solid #f90;
}

.suspension_title1 {
  width: 100%;
  height: 45px;
  padding: 5px;
  border: 1px solid #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.suspension_title2 {
  margin: 5px 0 0 0;
  width: 100%;
  height: 45px;
  padding: 5px;
  border: 1px solid #333;
}

.suspension_title3 {
  width: 3%;
  cursor: pointer;
}

.suspension_but {
  width: 100px;
  height: 25px;
  margin: 0 0 0 100px;
  line-height: 25px;
  text-align: center;
  color: #fffff3;
  background-color: #f90;
  border-radius: 30px;
  display: inline-block;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/TASMini/views/Im/components/message.vue